import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss'],
  standalone: false
})
export class NotFoundComponent {
  constructor(private router: Router, private storageService: StorageService) {}

  goHome() {
    const role = this.storageService.getRole();
    if (role === 'CLIENT') {
      this.router.navigate(['/doqfy/dashboard']);
    } else {
      this.router.navigate(['/doqfy/admin-dashboard']);
    }
  }
}
